import React from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import {
	generateRandomNumber,
	generateArrayFromLength,
} from '@gov-nx/utils/common';

export const HealthDocumentationSkeleton = () => {
	const { t } = useGlobalLocale();
	return (
		<ContentLayout>
			{generateArrayFromLength(3).map((i) => (
				<div
					key={i}
					className="w-full py-6 px-4 border-b border-(--border-subtlest) [ last-of-type:border-0 ]">
					<LayoutGap gap="s">
						<GovSkeleton
							width={generateRandomNumber(120, 270) + 'px'}
							height="30px"
							aria-label={t('loading.wcag.processing')}
						/>
						<div className="[ lg:w-[390px] ]">
							<GovSkeleton
								width="100%"
								height="24px"
								aria-label={t('loading.wcag.processing')}
							/>
						</div>
						<div className="flex flex-col gap-4 pt-2 [ md:flex-row ]">
							<div className="[ md:w-[220px] ]">
								<GovSkeleton
									width="100%"
									height="40px"
									aria-label={t('loading.wcag.processing')}
								/>
							</div>
							<div className="[ md:w-[220px] ]">
								<GovSkeleton
									width="100%x"
									height="40px"
									aria-label={t('loading.wcag.processing')}
								/>
							</div>
						</div>
					</LayoutGap>
				</div>
			))}
		</ContentLayout>
	);
};
